import { reactive } from "vue";

export const store = reactive({
    chosenLanguage: '',
    manualLanguageSelect: false,
    challengeCode: '',
})